import loading from "./loading.html";
import "./loading.css";

export const showLoadingView = () => {
    const body = document.querySelector("body");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    body.insertAdjacentHTML("beforeend", loading);
};

export const removeLoadingView = () => {
    const loadingView = document.querySelector("#loading-cockpit");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    loadingView.remove();
};
